module.exports = __webpack_public_path__ + "static/media/aw.47ea7038.svg";